import styled from 'styled-components'

export const InventoryWalletActions = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
`

export const InventoryWallerDropdown = styled.div`
    position: relative;
    width: 100%;
`

export const InventoryCloseIcon = styled.div`
    cursor: pointer;
`

export const InventoryWallerMenu = styled.div<{ menuOpen: boolean }>`
    display: ${properties => (properties.menuOpen ? 'block' : 'none')};
    position: absolute;
    top: 45px;
    right: 0px;
    background-color: #fff;
    padding: 10px 20px;
    width: 200px;
    border-radius: 5px;
    z-index: 9;
    box-shadow: 5px 5px 30px 0px lightgrey;

    > div {
        padding: 10px 0;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        &:not(:last-child) {
            border-bottom: 1px solid #e0e0e0;
        }
    }
`

export const DotColor = styled.div`
    width: 5px;
    height: 5px;
    border-radius: 100%;
    background-color: #99cc66;
`

export const ButtonInventoryText = styled.div`
    font-weight: 600;
    color: #000000;
    font-size: 16px;
    letter-spacing: 0px;
    line-height: 1.2;
`
